import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import { loadWorkshopProgram } from '../Program/actions/programActions';
import Workshops from './components/Workshops';

export const mapStateToProps = state => ({
    talksById: state.program.talksById,
    workshopTimeSlotsById: state.program.workshopTimeSlotsById,
    fetchingProgram: state.program.fetchingProgram,
    speakersById: state.speakers.speakersById
});

export const mapActionCreators = {
    pushAction,
    loadWorkshopProgram
};

export default connect(
    mapStateToProps,
    mapActionCreators
)(Workshops);
